import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';
import '../styles/NotificationToast.css';

function iconForType(type) {
  switch (type) {
    case 'new_match': return '🎉';
    case 'new_message': return '💬';
    case 'new_like': return '💗';
    default: return '🔔';
  }
}

export default function NotificationToast() {
  const { newArrival, dismissToast } = useNotifications();
  const navigate = useNavigate();

  useEffect(() => {
    if (!newArrival) return;
    const t = setTimeout(dismissToast, 4500);
    return () => clearTimeout(t);
  }, [newArrival, dismissToast]);

  if (!newArrival) return null;

  const handleClick = () => {
    const data = newArrival.data || {};
    if (newArrival.type === 'new_message' && data.match_id) {
      navigate(`/chat/${data.match_id}`);
    } else if (newArrival.type === 'new_match') {
      navigate('/matches');
    } else {
      navigate('/notifications');
    }
    dismissToast();
  };

  return (
    <div className="notification-toast" onClick={handleClick}>
      <div className="notification-toast-icon">
        {iconForType(newArrival.type)}
      </div>
      <div className="notification-toast-body">
        <div className="notification-toast-title">{newArrival.title}</div>
        <div className="notification-toast-text">{newArrival.body}</div>
      </div>
      <button
        className="notification-toast-close"
        onClick={(e) => {
          e.stopPropagation();
          dismissToast();
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}